<template>
  <section class="p-4">
    <slot></slot>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
